module.exports = __webpack_public_path__ + "img/guideInfo3.b3a14979.png";